export const REQUEST_REJECT_CLAIM: string = 'REJECT_CLAIM';
export const REQUEST_CLAIM_RECAP: string = 'REQUEST_CLAIM_RECAP';

export const REQUEST_OPEN_CLAIM: string = 'REQUEST_OPEN_CLAIM';
export const REQUEST_VALIDATE_VICTIM: string = 'REQUEST_VALIDATE_VICTIM';
export const REQUEST_VALIDATE_VEHICLE: string = 'REQUEST_VALIDATE_VEHICLE';
export const SET_CLAIM_RECAP: string = 'SET_CLAIM_RECAP';
export const RESET_STORE_CLAIM: string = 'RESET_STORE_CLAIM';
export const REQUEST_VALIDATE_COMPLETION_CLAIM_MANAGER: string =
  'REQUEST_VALIDATE_COMPLETION_CLAIM_MANAGER';
export const REQUEST_VALIDATE_PROVISION_INTERVENANT: string =
  'REQUEST_VALIDATE_PROVISION_INTERVENANT';

export const REQUEST_GET_FEE_NOTES_BY_CLAIM_ID =
  'REQUEST_GET_FEE_NOTES_BY_CLAIM_ID';

export const DEFAULT_LAWYER_CODE = '10003';

export const REQUEST_UPDATE_VICTIM_INFO: string = 'REQUEST_UPDATE_VICTIM_INFO';
export const REQUEST_UPDATE_BENEFICIARY_INFO: string =
  'REQUEST_UPDATE_BENEFICIARY_INFO';

export const REQUEST_UPDATE_VEHICLE_INFO: string =
  'REQUEST_UPDATE_VEHICLE_INFO';

export const REQUEST_ADD_CLAIM_NUMBER: string = 'REQUEST_ADD_CLAIM_NUMBER';
export const REQUEST_GET_SAGIS_CLAIM: string = 'REQUEST_GET_SAGIS_CLAIM';
export const REQUEST_SET_SAGIS_CLAIM: string = 'REQUEST_SET_SAGIS_CLAIM';

export const SET_CLAIM_HISTORY_ACTIONS: string = 'SET_CLAIM_HISTORY_ACTIONS';
export const REQUEST_CREATE_FEE_NOTE = 'REQUEST_CREATE_FEE_NOTE';

export const OTHER_REASON_ID = '3';
export const FRAUDE_CORPO = '5';

export const MANAGEMENT_MODES = {
  COMMON_RIGHT: '1',
  FOREIGN: '3',
};

export const SCALE_CASES_KEY = {
  OTHER: '8',
};

export const SEX = {
  MAN: 10,
  WOMAN: 20,
};

export const OPEN_CLAIM_CONSTANTS = {
  DECLARANT_LAWYER_CODE: '61',
};

export const MOROCCO_COUNTRY_CODE = '45';

export const OPPOSING_PARTY_NAME = 'CORPOREAL';

export const ITEM_KEYS = {
  LAWYER: '4',
  SUB_SERVICE: '29',
};

export const ASSIGNMENT_FIELDS = {
  LAWYER: 'lawyer',
  ASSIGNED_LAWYERS: 'assignedLawyers',
  SUB_SERVICE: 'subService',
  ASSIGNED_MANAGER: 'assignedManagerCode',
};

export const SAGIS_KEYS = {
  ITEM_TYPE: 'ItemType',
  ITEM_GROUP: 'ItemGroup',
};

export const REQUEST_ASSIGNMENT = 'REQUEST_ASSIGNMENT';

export const REQUEST_CORPOREAL_LAWYERS = 'REQUEST_CORPOREAL_LAWYERS';

export const SET_CORPOREAL_LAWYERS = 'SET_CORPOREAL_LAWYERS';
export const MATERIAL = 'Materiel';
export const CORPOREAL = 'Corporeal';
export const CORPOREAL_SAGIS = 'Corporel';
export const CLAIM_STATUS_SAGIS = {
  sansSuite: 'Sans suite',
  clos: 'Clos',
};
export const REQUEST_OPEN_MIXED_CLAIM = 'REQUEST_OPEN_MIXED_CLAIM';
export const SET_OPENED_CLAIM = 'SET_OPENED_CLAIM';
export const ASSIGNMENT_DIALOG_FIELDS = {
  FIRM_REFERENCE: 'firmReference',
};

export const PROVISION_INTERVENANT_FIELDS = {
  AMOUNT: 'amount',
  INTERVENANT: 'intervenant',
  CONTRACTOR_TYPE_CODE: 'contractorTypeCode',
  CONTRACTOR_CODE: 'contractorCode',
};

export const ManagerToTownCode = {
  '1': [83],
  '2': [83],
  '3': [484, 501, 489, 518, 539],
  '4': [485, 528, 473, 475, 393, 691, 474, 472],
  '5': [
    417,
    12225,
    407,
    583,
    416,
    623,
    423,
    140,
    215,
    430,
    529,
    132,
    436,
    527,
    458,
    469,
  ],
  '6': [156, 346, 167, 699, 155, 197],
  '7': [544, 563, 562, 373, 564],
  '8': [669, 214, 656, 647, 648, 639, 660],
  '9': [593, 591, 597, 627],
  '10': [268, 266, 294, 295, 302, 301],
  '11': [
    1,
    624,
    249,
    351,
    23,
    32,
    374,
    311,
    44,
    622,
    244,
    40,
    43,
    57,
    312,
    63,
    340,
    246,
    694,
    247,
  ],
  '12': [609, 282, 606, 607, 327, 185, 328],
  '13': [],
} as any;
export const OTHER_PROFESSION = '144';
